import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithRestApiByRequestUid,
} from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { AppMode } from 'app/store/general/AppMode';
import { IndexEventsWidget } from './components/IndexEventsWidget';
import { indexEventsDescription } from './description/indexEventsDescription';
import { IndexEventsRequest } from './api/IndexEventsRequest';
import { IndexEventsResponse } from './api/IndexEventsResponse';
import {
    IndexEventsWidgetConfigState,
    initialIndexEventsConfiguration,
} from './store/config/IndexEventsWidgetConfigState';
import { indexEventsStreamConfig } from './stream-config';

export const IndexEventsTitle = 'Index Events';

export const indexEventsWidgetStrategy: WidgetStrategyWithConfig<IndexEventsWidgetConfigState> &
    WidgetStrategyWithRestApiByRequestUid<
        IndexEventsRequest,
        IndexEventsResponse
    > = {
    title: IndexEventsTitle,
    supportedHosts: ['layout'],
    reactComponentType: IndexEventsWidget,
    categories: [
        {
            appModes: [AppMode.STANDALONE],
            categories: [WidgetCategory.MULTIPLE_STOCK],
        },
        {
            appModes: [AppMode.EMBEDDED_DASHBOARD],
            categories: [WidgetCategory.PORTFOLIO],
        },
    ],
    description: indexEventsDescription,
    initialConfigState: initialIndexEventsConfiguration,
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.AtLeastOneOrder,
    managedStreamConfig: indexEventsStreamConfig,
};
